var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormItem',{attrs:{"label":_vm.label,"required":!!_vm.required}},[_c('BaseFileSelectFull',_vm._b({attrs:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input',$event)}}},'BaseFileSelectFull',_vm.option,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }